import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, TextField, Grid, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  input: {
    width: '100%',
    borderLeft: 'none',
    '& .MuiOutlinedInput-root': {
      borderTopRightRadius: '0',
      borderBottomRightRadius: '0',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRight: 'none',
    },
  },
  button: {
    width: '48px',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function ConnectingElementCreator({ title, value, handleChange, handleClick }) {
  const classes = useStyles();
  return (
    <Grid item xs={12} md={6}>
      <Typography className={classes.title}>{title}</Typography>
      <Box className={classes.inputContainer}>
        <TextField
          variant="outlined"
          className={classes.input}
          value={value}
          type={'text'}
          placeholder="مورد خود را وارد کنید"
          onChange={e => handleChange(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          style={{ height: '56px', borderTopRightRadius: '0', borderBottomRightRadius: '0' }}
          onClick={handleClick}>
          <Add />
        </Button>
      </Box>
    </Grid>
  );
}
